import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicBasedMembershipGroupRepository from "../repositories/PublicBasedMembershipGroupRepository";

const usePublicMembershipGroupsService = () => {
  const repository = new PublicBasedMembershipGroupRepository();

  const modelService = useModelService(repository);

  return {
    ...modelService,
  };
};

export default usePublicMembershipGroupsService;

export type UsePublicMembershipGroupsService = ReturnType<
  typeof usePublicMembershipGroupsService
>;
